<template>
  <CModal :show="show" :closeOnBackdrop="false" :centered="true" size="lg">
    <template #header>
      <h5 class="modal-title">{{ title }}</h5>
    </template>
    <div v-if="!loading">
      <form @submit.prevent="onSubmit">
        <div class="form-group">
          <label>{{ $t("models.ppm.force_manual_price") }}</label>
          <div>
            <CSwitch color="primary" :checked.sync="form.force_manual_price" />
          </div>
        </div>

        <div class="form-group">
          <label>{{ $t("models.lot.is_active") }}</label>
          <div>
            <CSwitch color="primary" :checked.sync="form.active" />
          </div>
        </div>

        <div class="form-group">
          <label>{{ $t("models.ppm.price") }}</label>
          <CInput
            v-model.number="form.price"
            type="number"
            min="0"
            step="1"
            :disabled="!form.force_manual_price"
          />
        </div>

        <div class="form-group">
          <label>{{ $t("models.ppm.flag") }}</label>
          <select class="form-control" v-model.number="form.flag">
            <option :value="0">{{ $t("common.none") }}</option>
            <option v-for="flag in flags" :key="flag.value" :value="flag.value">
              {{ flag.label }}
            </option>
          </select>
        </div>
      </form>

      <CAlert v-if="validationError" color="danger" :show.sync="showAlert">
        {{ validationError }}
      </CAlert>
    </div>
    <div
      v-else
      class="d-flex justify-content-center align-items-center"
      style="height: 200px"
    >
      <CSpinner color="primary" />
    </div>

    <template #footer>
      <CButton color="primary" variant="outline" @click.prevent="closeModal">
        {{ $t("common.editor.cancel") }}
      </CButton>
      <vue-ladda
        :loading="loading"
        data-style="zoom-in"
        button-class="btn btn-primary px-4"
        @click.prevent="onSubmit"
      >
        {{ $t("common.editor.confirm") }}
      </vue-ladda>
    </template>
  </CModal>
</template>

<script>
import { apiPatch, apiPost, apiGet } from "../../../helpers/apiHelper";

export default {
  name: "ShowcasePricesModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    editId: {
      type: [Number, String],
      default: null,
    },
    values: {
      type: Object,
      default: () => ({}),
    },
    flags: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      loading: false,
      validationError: null,
      showAlert: false,
      form: {
        force_manual_price: false,
        active: false,
        price: 0,
        flag: 0,
      },
    };
  },

  computed: {},

  watch: {
    show: {
      handler(isShown) {
        if (isShown) {
          if (this.values && Object.keys(this.values).length > 0) {
            this.populateForm(this.values);
          } else {
            this.resetForm();
          }
        }
      },
      immediate: false,
    },
    values: {
      handler(newValues) {
        if (newValues && Object.keys(newValues).length > 0) {
          this.populateForm(newValues);
        }
      },
      immediate: true,
    },
  },

  methods: {
    populateForm(data) {
      this.form.force_manual_price = data.ppm?.force_manual_price || false;
      this.form.active = data.ppm?.active || false;
      this.form.price = data.ppm?.price || 0;
      this.form.flag = data.ppm?.flag || 0;
      this.loading = false;
    },

    async onSubmit() {
      this.validationError = null;
      this.showAlert = false;

      let requestParams = this.values;
      let flag = null;
      this.form.flag !== 0 && (flag = this.form.flag);

      requestParams.ppm.force_manual_price = this.form.force_manual_price;
      requestParams.ppm.active = this.form.active;
      requestParams.ppm.price = this.form.price;
      requestParams.ppm.flag = flag;

      // check user permissions before submitting
      const perm = this.$store.state.connections.current.permissions.role_pp;
      if (perm !== 2) {
        this.validationError = this.$t(
          "models.market_plan.addForm.validation.permissions"
        );
        this.showAlert = true;
        return;
      }

      let response;
      if (this.editId) {
        response = await apiPatch(
          "role_market_ppm",
          this.editId,
          requestParams,
          [this.$store.state.role.id]
        );
      }

      if (response && response.status === 200) {
        this.$emit("submitted");
        this.closeModal();
      } else {
        this.$store.dispatch("toaster/add", {
          title: this.$t("role.finance.invoicesSettings.attention"),
          text: "Error saving data",
          color: "danger",
          autohide: true,
        });
      }
    },

    closeModal() {
      this.$emit("update:show", false);
      this.validationError = null;
      this.showAlert = false;
    },

    resetForm() {
      this.form = {
        force_manual_price: false,
        active: false,
        price: 0,
        flag: 0,
      };
      this.validationError = null;
      this.showAlert = false;
    },
  },
};
</script>
